import { useEffect, useState } from 'react';
import styles from './components.module.scss';
import { IconClock } from '@tabler/icons-react';

export const TimeSection = () => {
  const [time, setTime] = useState('');

  useEffect(() => {
    /* eslint-disable no-undef */
    // Initial update
    const initialUpdate = window.setTimeout(() => {
      setTime(new Date().toLocaleTimeString());
    }, 1000 - new Date().getMilliseconds());

    // Regular updates
    const interval = window.setInterval(() => {
      setTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => {
      window.clearInterval(interval);
      window.clearTimeout(initialUpdate);
    };
    /* eslint-enable no-undef */
  }, []);

  return (
    <div className={styles.timeSection}>
      <IconClock size={16} className={styles.timeSection__icon} />
      <span className={styles.timeSection__text}>{time}</span>
    </div>
  );
};
